import axios from 'axios';

import appConfig from 'app-config';

import { ArticleList } from 'src/types/zendesk';

const API_PATH = appConfig.helpCenterApiUrl;

export enum TermsType {
  termsOfService = 'tos',
  privacyPolicy = 'pp',
  locationBasedTerms = 'lbt',
  cookiePolicy = 'cp',
}

const SECTION_IDS: Record<TermsType, number> = {
  [TermsType.termsOfService]: appConfig.helpCenterSectionIds.termsOfService,
  [TermsType.privacyPolicy]: appConfig.helpCenterSectionIds.privacyPolicy,
  [TermsType.locationBasedTerms]: appConfig.helpCenterSectionIds.locationBasedTerms,
  [TermsType.cookiePolicy]: appConfig.helpCenterSectionIds.cookiePolicy,
};

const getArticleUrlWithoutLocale = (url: string) => {
  const urlWithoutLocale = url.replace(/\/hc\/[a-z]{2}(-[a-z]{2})?\//, '/hc/');
  return urlWithoutLocale;
};

export const getRecentTerms = async (
  type: TermsType,
  lang?: string
): Promise<string | undefined> => {
  const url = new URL(API_PATH);

  const sectionId = SECTION_IDS[type];

  // iOS safari에서 301 redirect를 통한 재요청시, 원본 요청의 header가 누락되는 이슈가 있음
  // Zendesk API에서 accept 포맷을 전송하지 않으면 415 error가 발생하기 때문에, accept 포맷을 header 대신 endpoint에 명시함
  if (lang) {
    url.pathname += `/${lang}/sections/${sectionId}/articles.json`;
  } else {
    url.pathname += `/sections/${sectionId}/articles.json`; // zendesk default language로 획득됨
  }

  const response = await axios.get<ArticleList>(url.toString());

  const articles = response.data.articles;

  const articleUrl = articles[0]?.html_url;
  if (articleUrl) {
    /**
     * 명시적으로 코드 주어지지 않았으면 기본언어 제거된 url로 보내서 헬프센터가 알아서 리다이렉트 유도
     * 반면 명시적으로 기본 locale이 포함된 채로 이동시 헬프센터 자동 리다이렉트 불가
     */
    return lang ? articleUrl : getArticleUrlWithoutLocale(articleUrl);
  }
};
export const goRecentTerms = (type: TermsType, lang?: string) =>
  getRecentTerms(type, lang).then((url) => {
    if (url) window.location.replace(url);
    else window.location.replace('/');
  });

export const SAFETY_TIPS_URL = 'https://help.azarlive.com/hc/articles/47827076635161';
